import { faPen } from "@fortawesome/pro-light-svg-icons";
import { faIdCard } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { type CardIdentifier as CardIdentifierType } from "@kanpla/api-contract";
import { useState } from "react";
import { faCircle } from "@fortawesome/pro-solid-svg-icons";

import { T } from "@repo/transifex";

import { EditKanplaCardIdModal } from "./edit-kanpla-card-id-modal";

type CardIdentifierProps = {
  cardIdentifier: CardIdentifierType | null;
  childId: string;
};

export const CardIdentifier = ({
  cardIdentifier,
  childId
}: CardIdentifierProps) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  return (
    <>
      <section className="flex items-center justify-center">
        <div className="flex h-9 w-40 items-center justify-center gap-2 rounded-lg px-2 py-0">
          <FontAwesomeIcon
            icon={faIdCard}
            className="h-4 w-auto text-interface-warning-4"
          />
          <span className="flex items-center justify-center gap-1 text-center text-base font-normal leading-4 text-interface-warning-4">
            {cardIdentifier?.value ? (
              Array.from({ length: String(cardIdentifier.value).length }).map(
                (_, index) => (
                  <FontAwesomeIcon
                    // eslint-disable-next-line react/no-array-index-key -- this is a unique key for the array
                    key={index}
                    icon={faCircle}
                    className="size-1"
                  />
                )
              )
            ) : (
              <T _str="Not set" />
            )}
          </span>
          <button
            type="button"
            className="flex size-9 items-center justify-center rounded-full bg-interface-warning-1 p-6 text-interface-warning-4"
            onClick={() => {
              setIsEditModalOpen(true);
            }}
          >
            <FontAwesomeIcon icon={faPen} className="size-4" />
          </button>
        </div>
      </section>

      {isEditModalOpen ? (
        <EditKanplaCardIdModal
          childId={childId}
          currentCardIdentifier={cardIdentifier}
          onClose={() => {
            setIsEditModalOpen(false);
          }}
        />
      ) : null}
    </>
  );
};
